import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import { UpsellConditionStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface UpsellConditionNodeData {
  step: PartialWithRequiredType<UpsellConditionStep>;
}

export function UpsellConditionNode(data: {
  id: string;
  data: UpsellConditionNodeData;
  selected?: boolean | undefined;
}) {
  return (
    <>
      <BaseNode
        icon={
          <RedoFeaturedIcon color="black" Icon={CursorClickIcon} size="xs" />
        }
        selected={data.selected}
        step={data.data.step}
        title="Post purchase upsell"
      />
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
